import PropTypes from 'prop-types';
import { getTokensPropType } from '../utils/props/tokens';
import variantProp from '../utils/props/variantProp';
const propTypes = {
  /**
   * Used to render the control (i.e. tooltip trigger). If a render function is used it will receive the
   * pressable state and tooltip variant as an argument.
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  /**
   * The message. Can be raw text or text components.
   */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Select English or French copy for the accessible label.
   */
  copy: PropTypes.oneOf(['en', 'fr']),
  /**
   * Use to place the tooltip in a specific location (only if it fits within viewport).
   */
  position: PropTypes.oneOf(['auto', 'above', 'right', 'below', 'left']),
  /**
   * Display tooltip icon button as an inline element.
   */
  inline: PropTypes.bool,
  /**
   * Callback function triggered when the tooltip is pressed.
   */
  onPress: PropTypes.func,
  /**
   * The `id` of the tooltip button.
   */
  nativeID: PropTypes.string,
  /**
   * Set to `true` to open the tooltip on hover
   */
  activateOnHover: PropTypes.bool,
  tooltipButtonTokens: getTokensPropType('TooltipButton'),
  tokens: getTokensPropType('Tooltip'),
  variant: variantProp.propType
};
export default propTypes;